import React, {useEffect, useState} from 'react'
import { apiFetch } from './api'
import { useNavigate } from 'react-router-dom'

export default function SecretAdmin(){
  const [user,setUser]=useState(null)
  const [loading,setLoading]=useState(true)
  const [logs,setLogs]=useState([])
  const [logsLoading,setLogsLoading]=useState(false)
  const [page,setPage]=useState(0)
  const [totalPages,setTotalPages]=useState(0)
  const nav = useNavigate()

  useEffect(()=>{
    apiFetch('/api/me', {credentials:'include'})
      .then(r => r.ok ? r.json() : null)
      .then(data => {
        if (!data) {
          nav('/login')
          return
        }
        setUser(data)
        if (!data.roles || !data.roles.includes('ROLE_ADMIN')) {
          // not authorized
          setUser({ ...data, unauthorized: true })
        }
        if (data && data.roles && data.roles.includes('ROLE_ADMIN')) {
          loadLogs()
        }
      })
      .finally(()=>setLoading(false))
  },[])

  const loadLogs = (nextPage = 0) => {
    setPage(nextPage)
    setLogsLoading(true)
    apiFetch(`/api/admin/logs?page=${nextPage}&size=9`, {credentials:'include'})
      .then(r => r.ok ? r.json() : { content: [], totalPages: 0 })
      .then(data => {
        setLogs(data.content || [])
        setTotalPages(data.totalPages || 0)
      })
      .finally(()=>setLogsLoading(false))
  }

  const formatDate = iso => {
    if (!iso) return ''
    const d = new Date(iso)
    return d.toLocaleString()
  }

  if (loading) return <div style={{padding:20}}>Loading…</div>
  if (user && user.unauthorized) return <div style={{padding:20}}>Access denied — admin only.</div>

  return (
    <div style={{padding:20,display:'flex',flexDirection:'column',gap:16}}>
      <div>
        <h1 style={{marginBottom:4}}>Logs</h1>
        <p style={{color:'#4b5563'}}>Only admins can see this page. Welcome, <strong>{user?.username}</strong>.</p>
      </div>

      <div style={{background:'#fff',border:'1px solid #e5e7eb',borderRadius:12,boxShadow:'0 12px 30px rgba(17,24,39,0.08)',padding:18}}>
        <div style={{display:'flex',justifyContent:'space-between',alignItems:'center',marginBottom:12}}>
          <div>
            <div style={{fontWeight:700,fontSize:16}}>Audit log</div>
            <div style={{color:'#6b7280',fontSize:13}}>User actions across supervisors, routes, vendors, and users.</div>
          </div>
          <button className="btn secondary" onClick={()=>loadLogs(page)} disabled={logsLoading}>{logsLoading ? 'Refreshing…' : 'Refresh'}</button>
        </div>
        <div style={{maxHeight:420,overflowY:'auto',border:'1px solid #eef2f7',borderRadius:10}}>
          <table className="report-table" style={{width:'100%', borderCollapse:'separate', borderSpacing:0}}>
            <thead>
              <tr style={{background:'#f8fafc',position:'sticky',top:0}}>
                <th style={{textAlign:'left',padding:'10px 12px'}}>Time</th>
                <th style={{textAlign:'left',padding:'10px 12px'}}>User</th>
                <th style={{textAlign:'left',padding:'10px 12px'}}>Action</th>
                <th style={{textAlign:'left',padding:'10px 12px'}}>Entity</th>
                <th style={{textAlign:'left',padding:'10px 12px'}}>Detail</th>
              </tr>
            </thead>
            <tbody>
              {logs && logs.length > 0 ? logs.map(log => (
                <tr key={log.id}>
                  <td style={{padding:'10px 12px',whiteSpace:'nowrap'}}>{formatDate(log.createdAt)}</td>
                  <td style={{padding:'10px 12px'}}>{log.username}</td>
                  <td style={{padding:'10px 12px',textTransform:'capitalize'}}>{log.action?.toLowerCase()}</td>
                  <td style={{padding:'10px 12px'}}>{log.entityType}{log.entityId ? ` #${log.entityId}` : ''}</td>
                  <td style={{padding:'10px 12px',color:'#4b5563'}}>{log.detail}</td>
                </tr>
              )) : (
                <tr>
                  <td colSpan={5} style={{padding:14,color:'#6b7280'}}>No logs yet.</td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
          <div style={{display:'flex',justifyContent:'space-between',alignItems:'center',marginTop:12}}>
            <button className="btn secondary" onClick={()=>loadLogs(Math.max(0, page-1))} disabled={logsLoading || page<=0}>Prev</button>
            <div style={{fontSize:13,color:'#4b5563'}}>Page {page+1} of {Math.max(totalPages,1)}</div>
            <button className="btn secondary" onClick={()=>loadLogs(page+1)} disabled={logsLoading || (totalPages>0 && page>=totalPages-1)}>Next</button>
          </div>
      </div>
    </div>
  )
}
